/**
 * Academy Slider – scroll-coupled effects on top of the shared Swiper init.
 * ---------------------------------------------------------------------------
 * Mirrors the reference functions Co() / Mo() (see academy-timeline.js):
 *
 *   Co()  → [data-slider-inview] (opt-in, section setting): as soon as the
 *           section hits `top 75%`, advance the slider ONCE by one card
 *           (goToNext equivalent → swiper.slideNext()).
 *   Mo()  → [data-slider-parallax] / [data-slider-parallax-item] (opt-in):
 *           each item gets a gentle scroll-coupled yPercent offset (5),
 *           trigger `top bottom` → `bottom top`, scrub.
 *
 * Both need GSAP + ScrollTrigger; without them (or with reduced motion) it
 * is a no-op. The Swiper instance itself is created by academy-swiper.js —
 * Swiper stores it on the container element as `.swiper`.
 */
(function () {
  var REDUCE_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function withSwiper(section, cb, tries) {
    var container = section.querySelector('.swiper');
    if (container && container.swiper) {
      cb(container.swiper, container);
      return;
    }
    if ((tries || 0) > 60) return;
    requestAnimationFrame(function () {
      withSwiper(section, cb, (tries || 0) + 1);
    });
  }

  function initScrollEffects(section) {
    var gsap = window.gsap;
    var ScrollTrigger = window.ScrollTrigger;
    if (!gsap || !ScrollTrigger || REDUCE_MOTION) return;

    // ── Co(): one-off "advance one card" when the section scrolls in ──
    if (section.hasAttribute('data-slider-inview')) {
      withSwiper(section, function (swiper) {
        gsap.timeline({
          scrollTrigger: {
            trigger: section,
            start: 'top 75%',
            once: true,
            onEnter: function () {
              if (swiper && !swiper.destroyed && !swiper.isLocked) {
                swiper.slideNext();
              }
            }
          }
        });
      });
    }

    // ── Mo(): scrub parallax on the parallax items ──────────────────
    section.querySelectorAll('[data-slider-parallax]').forEach(function (root) {
      var items = root.querySelectorAll('[data-slider-parallax-item]');
      if (!items.length) return;
      gsap
        .timeline({
          scrollTrigger: {
            trigger: root,
            start: 'top bottom',
            end: 'bottom top',
            scrub: 1
          }
        })
        .to(items, { yPercent: 5, ease: 'none', duration: 1 });
    });
  }

  function init(root) {
    (root || document).querySelectorAll('.academy-slider[data-academy-swiper]').forEach(initScrollEffects);
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  }

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      init(e.target);
    });
  }
})();
